import ListLayout from "../../../components/layout/main/ListLayout";
import { PageCard } from "../../../styles/CommonStyles";
import { useState } from "react";
import ModalLayout from "../../../components/layout/main/ModalLayout";
import PairCategoryModal from "../../../components/main/setting/category/PairCategoryModal";
import Tooltip from "../../../components/common/utils/Tooltip";
import { AddIcon } from "../../../styles/main/setting";
import { useGetCategories } from "../../../core/services/react-query/setting/category";
import PairCategoryListing from "../../../components/main/setting/category/PairCategoryListing";


const CategoryPage = () => {
    const { data: categories, isLoading } = useGetCategories();

    const [catModalOpen, setCatModalOpen] = useState(false)
    const closeCatModal = () => setCatModalOpen(false)
    const openCatModal = () => setCatModalOpen(true)

    return (
        <ListLayout>
            <PageCard>
                <Tooltip content={'add-category'}>
                    <div onClick={openCatModal}>
                        <AddIcon size={24} />
                    </div>
                </Tooltip>
                <PairCategoryListing categories={categories} isLoading={isLoading} />
            </PageCard>
            <ModalLayout
                width={'700px'}
                open={catModalOpen}
                onClose={closeCatModal}
            >
                <PairCategoryModal
                    existingCategories={categories}
                    onSuccess={closeCatModal}
                />
            </ModalLayout>
        </ListLayout>
    )
}

export default CategoryPage
